import { TextFieldTheme } from 'wix-ui-tpa/cssVars';
import { InputBorderStyle } from '../../constants';
import { getInputBorderStyle } from '../../contexts/style-params-context';
export function getTextInputTheme(styleParams, mobile) {
  const borderStyle = getInputBorderStyle(styleParams, mobile);
  return borderStyle === InputBorderStyle.Bottom ? TextFieldTheme.Line : TextFieldTheme.Box;
}
export const getIsBorderStyleNone = (styleParams, mobile) => {
  const borderStyle = getInputBorderStyle(styleParams, mobile);
  return borderStyle === InputBorderStyle.None;
};
export const getIsBorderStyleBottom = (styleParams, mobile) => {
  const borderStyle = getInputBorderStyle(styleParams, mobile);
  return borderStyle === InputBorderStyle.Bottom;
};
//# sourceMappingURL=utils.js.map